import axios from 'axios'

const env = (process.env.NODE_ENV === 'production')

const config = () => {
  return {
    url: env ? 'https://fdc-api.brique.kr' : 'http://localhost',
    port: env ? '' : ':'.concat('20004'),
    service: '/fdc/info'
  }
}

export default {
  /**
   * FAB Info
   */
  getFabs: async () => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/fabs')
      return response.data === null ? [] : response.data
    } catch (error) {
      console.error(error)
    }
  },
  addFab: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + config().service + '/fab', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  putFab: async (payload) => {
    try {
      let response = await axios.put(config().url + config().port + config().service + '/fab', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  // FIXME: putFab(edit)과 deleteFab(useYn 변경) service 로직 다름. POST saveFab /fdc/info/fab/delete로 임시 처리
  saveFab: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + config().service + '/fab/delete', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  getFabsString: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/fabs/string', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  getLinesString: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/lines/string', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  getAreasString: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/areas/string', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  getVendersString: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/venders/string', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  getEqpModelsString: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/eqp-models/string', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * EQP Info
   */
  getEqps: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/eqps', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  addEqp: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + config().service + '/eqp', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  putEqp: async (payload) => {
    try {
      let response = await axios.put(config().url + config().port + config().service + '/eqp', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  getEqpValid: async (payload) => {
    // console.log('eqpKeyValidation')
    try {
      let response = await axios.get(config().url + config().port + config().service + '/eqp/valid', { params: payload })
      return response.data
    } catch (error) {
      console.log(error)
    }
  },
  getEqpModules: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/eqp/modules', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  getEqpCount: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + config().service + '/eqp/count', payload)
      return response.data === null ? 0 : response.data
    } catch (error) {
      console.log(error)
    }
  },
  runEqpCopy: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + config().service + '/eqp/copy', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * EQP Event Info
   */
  getEqpEvents: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/events', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  addEqpEvent: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + config().service + '/event', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  putEqpEvent: async (payload) => {
    try {
      let response = await axios.put(config().url + config().port + config().service + '/event', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  getEqpEventValid: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/event/valid', { params: payload })
      return response.data
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * EQP Recipe Info
   */
  getEqpRecipes: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/recipes', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  saveEqpRecipe: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + config().service + '/recipe', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  putEqpRecipe: async (payload) => {
    try {
      let response = await axios.put(config().url + config().port + config().service + '/recipe', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  getEqpRecipeValid: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/recipe/valid', { params: payload })
      return response.data
    } catch (error) {
      console.log(error)
    }
  },
  getEqpRecipeSteps: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/recipe/steps', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  putEqpRecipeStep: async (payload) => {
    try {
      let response = await axios.put(config().url + config().port + config().service + '/recipe/step', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  getEqpRecipeStepValid: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/recipe/step/valid', { params: payload })
      return response.data
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * EQP Param Info
   */
  getEqpParams: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/params', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  addEqpParam: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + config().service + '/param', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  putEqpParam: async (payload) => {
    try {
      let response = await axios.put(config().url + config().port + config().service + '/param', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  getEqpParamValid: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/param/valid', { params: payload })
      return response.data
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * Realtime Monitor, Parameter Analysis
   */
  getEqpsParams: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/eqps/params', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * Analysis
   */
  getEqpParamsString: async (payload) => {
    // console.log('FdcEqpInfo paramNameList')
    try {
      let response = await axios.get(config().url + config().port + config().service + '/params/string', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  }
}
